import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from "react-router-dom";
import * as Common from '@/utils/Common'; 
// import '../../css/main.css';
import '@/css/main.css';

import TabPage from './TabList';

export default function AppMain({ open, drawerWidth, children }) {
    const history = useHistory();
    const location = history.location.pathname;
    const bigi = Common.getToken("bigi");

    const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    flexShrink: 1, // 공간이 부족하면 줄어들게 설정
    minWidth: 0,   // flex 자식 요소의 최소 너비 제한 해제
    marginLeft: 0,
    marginTop: "60px",
    transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
},
contentShift: {
    marginLeft: 220, // 220px 밀어냄
    width: 'auto',   // width를 100%로 강제하지 않음
    transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
    }),
},
        // content: {
        //     flexGrow: 1,
        //     // padding: theme.spacing(3),
        //     // transition: theme.transitions.create('margin', {
        //     //     easing: theme.transitions.easing.sharp,
        //     //     duration: theme.transitions.duration.leavingScreen,
        //     // }),
            
        //      marginLeft: 0,
        //     marginTop: "40px",
        //      padding: "0px",
        //     marginLeft : 0
        //     //   marginLeft: -drawerWidth,

        //     // display: "flex",
        //     // flexFlow: "column nowrap",
        //     // width: "100%",
        //     // height: "100%",
        //     // minWidth: "1000px",
        // },
        // contentShift: {
        //     transition: theme.transitions.create('margin', {
        //         easing: theme.transitions.easing.easeOut,
        //         duration: theme.transitions.duration.enteringScreen,
        //     }),
        //     marginLeft: 220,
        // },

    // content: {
    //     flexGrow: 1,
    //     padding: theme.spacing(3),
    //     // margin과 width 모두에 부드러운 애니메이션 적용
    //     transition: theme.transitions.create(['margin', 'width'], {
    //         easing: theme.transitions.easing.sharp,
    //         duration: theme.transitions.duration.leavingScreen,
    //     }),
    //     marginLeft: 0,
    //     marginTop: "40px",
    //     width: '100%', // 기본 상태는 100%
    // },
    // contentShift: {
    //     // Drawer가 열렸을 때의 너비 계산 (핵심!)
    //     width: `calc(100% - 190px)`, 
    //     marginLeft: 190,
    //     transition: theme.transitions.create(['margin', 'width'], {
    //         easing: theme.transitions.easing.easeOut,
    //         duration: theme.transitions.duration.enteringScreen,
    //     }),
    // },



    }));

    const classes = useStyles();

    return (
        <main
            className={clsx(classes.content, {
                [classes.contentShift]: open,
            }) //+ " content_section"
            }
        >
            {location === "/" || location === "/unauthorized" || location === "/multiIp" || location === "/NotFoundPage" || location === "/print-history"
                ? children
                : <TabPage id={"tabid"} location={location} panel={children} />}
        </main>
    );
}
